import { Header, Page, PageMainVariant, TableWidget } from '@revolut-internal/ui-kit'

import { InboxesTable } from './InboxesTable'
import { InboxesActions } from './InboxesActions'
import { InboxesSummary } from './InboxesSummary'

export const Inboxes = () => {
  return (
    <Page.Main variant={PageMainVariant.WIDE}>
      <Header variant="main" scrollMode="manual">
        <Header.Title>Inboxes</Header.Title>
      </Header>

      <TableWidget>
        <InboxesSummary />
        <InboxesActions />
        <InboxesTable />
      </TableWidget>
    </Page.Main>
  )
}
